<template>
  <div class="p-1" id="footer">
    <div
      class="bg-white dark:bg-gray-800 p-2 border dark:border-gray-700 rounded-md"
      :class="compact === true ? '' : 'mt-5'"
      style="margin-right: 1% !important; margin-left: 1% !important;"
    >
      <div class="wrapper-link flex text-sm text-gray-400 text-center justify-center align-center">
        <router-link to="/" exact class="text-blue-500 cursor-pointer mx-2 hover:underline">{{ t('sidebar.dashboard', 'Dashboard') }}</router-link>
        <span class="mx-1">·</span>
        <router-link to="/aiChatAgents" class="text-blue-500 cursor-pointer mx-2 hover:underline">{{ t('sidebar.aiChatAgents', 'AI Chat Agents') }}</router-link>
        <span class="mx-1">·</span>
        <router-link to="/organizationUsage" class="text-blue-500 cursor-pointer mx-2 hover:underline">{{ t('sidebar.organizationUsage', 'Usage') }}</router-link>
        <div style="display: none;">
          <router-link :to="{ path: '/legal/dpa' }" class="text-blue-500 cursor-pointer">{{ t('footer.links.dpa','DPA') }}</router-link>
          <router-link :to="{ path: '/termsAndConditions', hash: '#cookies' }" class="text-blue-500 cursor-pointer">{{ t('footer.links.cookies','Cookie Policy') }}</router-link>
          <router-link :to="{ path: '/termsAndConditions', hash: '#privacy' }" class="text-blue-500 cursor-pointer">{{ t('footer.links.privacy','Privacy Policy') }}</router-link>
          <router-link :to="{ path: '/termsAndConditions', hash: '#terms' }" class="text-blue-500 cursor-pointer">{{ t('footer.links.terms','Terms and conditions') }}</router-link>
          <router-link to="#" class="text-blue-500 cursor-pointer">Licensing</router-link>
          <router-link to="#" class="text-blue-500 cursor-pointer">Contact</router-link>
        </div>
      </div>
    </div>
    <footer class="w-full box-border p-1 mt-3 text-center">
      <p class="text-sm dark:text-gray-400">
        © {{ new Date().getFullYear() }} {{ globalState.whitelabel?.appName !== undefined && globalState.whitelabel?.appName !== null && globalState.whitelabel?.appName !== '' ? globalState.whitelabel?.appName : 'Sonarix' }}
      </p>
    </footer>
  </div>
</template>

<script setup>
import { globalState } from '@/globalState';
import { useI18n } from '@/i18n';

defineProps({
  compact: {
    type: Boolean,
    default: false
  }
});

const { t } = useI18n();
</script>
